import { useContext } from 'react'

import { Collapse, Tooltip } from 'antd'
import { faSmile } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { getTimezoneLessMoment } from '../../../utils/momentjs'
import { isObject } from '../../../utils'
import InternshipStatePellet from '../../../Components/shared/InternshipStatePellet'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import InternshipItem from '../../../Components/student/InternshipItem'
import { InternshipStates } from '../../../utils/constants'
import { EvaluationsContext } from '../../../Providers/EvaluationsProvider'
import { StudentContext } from '../../../Providers/StudentProvider'
import { DATE_FORMAT_SHOWN } from '../../../Components/shared/InternshipsManager/utils/constants'

const Panel = Collapse.Panel

const { PENDING, ACCEPTED, SCHEDULE_ADDED, SCHEDULE_VALIDATED, SCHEDULE_TO_VALIDATE, ACCEPTED_UNMANAGED, AUTO_ACCEPTED } = InternshipStates

const InternshipList = ({ internships, onSelect, onUpdate }) => {
  const { freefields, schoolOptions } = useContext(StudentContext)
  const { internshipsToEvaluate } = useContext(EvaluationsContext)

  const t = useSelector(selectTranslate)

  return (
    <Collapse bordered={false} accordion>
      {internships.map(i => {
        const start = getTimezoneLessMoment(i.startDate).format(DATE_FORMAT_SHOWN)
        const end = getTimezoneLessMoment(i.endDate).format(DATE_FORMAT_SHOWN)
        const institution = isObject(i.institution) ? i.institution.name : t('Undefined institution')
        const disabled = ![PENDING, ACCEPTED, SCHEDULE_ADDED, SCHEDULE_VALIDATED, SCHEDULE_TO_VALIDATE, ACCEPTED_UNMANAGED, AUTO_ACCEPTED].includes(i.state)

        let title = (
          <div className='flex-column'>
            {institution} <br />
            {t('From') + ' ' + start + ' ' + t('to') + ' ' + end}<br />
            <InternshipStatePellet internship={i} showLabel />
          </div>
        )

        if (internshipsToEvaluate.find(internship => internship.id === i.id)) {
          title = (
            <div className='internship-item-title'>
              {title}
              <div className='exclamation-container'>
                <Tooltip
                  title={t('This internship has to be evaluated')}
                >
                  <FontAwesomeIcon icon={faSmile} size='2x' />
                </Tooltip>
              </div>
            </div>
          )
        }

        return (
          <Panel header={title} key={i.id} disabled={disabled}>
            {!disabled && (
              <InternshipItem
                internship={i}
                schoolOptions={schoolOptions}
                studentFreeFields={freefields}
                onInternshipSelect={onSelect}
                onUpdate={onUpdate}
              />
            )}
          </Panel>
        )
      })}
    </Collapse>
  )
}

export default InternshipList
